var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 27,
    height: 27,
    viewBox: "0 0 48 48",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12.5 4 C 10.015 4 8 6.015 8 8.5 L 8 39.5 C 8 41.985 10.015 44 12.5 44 L 35.5 44 C 37.985 44 40 41.985 40 39.5 L 40 20 L 28.5 20 C 26.015 20 24 17.985 24 15.5 L 24 4 L 12.5 4 z M 27 4.8789062 L 27 15.5 C 27 16.327 27.673 17 28.5 17 L 39.121094 17 L 27 4.8789062 z M 19.5 24.060547 C 20.881 24.060547 22 25.179547 22 26.560547 C 22 27.941547 20.881 29.060547 19.5 29.060547 C 18.119 29.060547 17 27.941547 17 26.560547 C 17 25.179547 18.119 24.060547 19.5 24.060547 z M 28.5 24.060547 C 29.881 24.060547 31 25.179547 31 26.560547 C 31 27.941547 29.881 29.060547 28.5 29.060547 C 27.119 29.060547 26 27.941547 26 26.560547 C 26 25.179547 27.119 24.060547 28.5 24.060547 z M 18.4375 32.324219 C 18.917998 32.292178 19.405781 32.492344 19.722656 32.902344 C 20.759656 34.235344 22.318 35 24 35 C 25.682 35 27.239391 34.234391 28.275391 32.900391 C 28.784391 32.245391 29.726859 32.128719 30.380859 32.636719 C 31.035859 33.145719 31.153484 34.086234 30.646484 34.740234 C 29.037484 36.812234 26.615 38 24 38 C 21.385 38 18.962516 36.811234 17.353516 34.740234 C 16.845516 34.086234 16.964141 33.143719 17.619141 32.636719 C 17.864391 32.445844 18.149201 32.343443 18.4375 32.324219 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.47ca5e3ea0f2ff25f70b900b6440097e.svg";
export { ForwardRef as ReactComponent };